
// quand octane.quiz.completed est déclenché
document.addEventListener('octane.quiz.completed', function (e) {
    // Trouver tous les éléments sélectionnés
    console.log('Octane Completed');
    const selectElements = document.querySelectorAll('select');

    // Itérer sur chaque élément sélectionné
    selectElements.forEach(select => {
        // Trouvez l’option avec la valeur "-1"
        const optionToChange = select.querySelector('option[value="-1"]');

        // Si l’option est trouvée, modifiez son texte
        if (optionToChange) {
            optionToChange.textContent = 'Choisir sa taille';
        }
    });

    // Trouvez tous les éléments <a> qui contiennent la classe « oct-quiz-result-item__title ».
    const links = document.querySelectorAll('a.oct-quiz-result-item__title');

    // Itérer sur chaque élément <a>
    links.forEach(link => {
        // Remplacer la liste des classes par les nouvelles classes
        link.className = 'font-neueSemiBold uppercase text-[11px] md:text-[12px] lg:text[14px] xl:text[16px] text-left';
    });
});

document.addEventListener('octane.quiz.addToCart', function (e) {
    // Your code for successfully added items
    //console.log(e.detail); // Example: {items: [{id: '12345', quantity: 1}]}
    //openSideCart(); // Call the function to open the side cart
}, false);

